import { useEffect, useState } from 'react';
import { getSessionEmpresaId, isSessionSuperAdmin } from '../../../../../utils/SessionUser';

const EMPTY = {
  nombreRedSocial: '',
  idEmpresa: '',
  activo: true,
};

export default function RedesSocialesModal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({ nombreRedSocial: '' });

  const userEmpresaId = getSessionEmpresaId();
  const isSuperAdmin = isSessionSuperAdmin();

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    if (field === 'nombreRedSocial' && !value) {
      error = 'El nombre de la red social es requerido.';
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    return validateField('nombreRedSocial', form.nombreRedSocial);
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (field === 'nombreRedSocial') validateField('nombreRedSocial', value);
  };

  useEffect(() => {
    if (!open) return;
    if (mode === 'edit' && data) {
      setForm({
        nombreRedSocial: data.nombreRedSocial ?? '',
        idEmpresa: data.idEmpresa != null ? String(data.idEmpresa) : '',
        activo: data.activo ?? true,
      });
    } else {
      setForm({
        ...EMPTY,
        idEmpresa: !isSuperAdmin ? String(userEmpresaId) : '',
      });
      setErrors({ nombreRedSocial: '' });
    }
  }, [open, mode, data, isSuperAdmin, userEmpresaId]);

  if (!open) return null;

  const handleSubmit = () => {
    if (!validateAll()) return;
    
    const payload = {
      NombreRedSocial: form.nombreRedSocial,
      IdEmpresa: (form.idEmpresa === '' || form.idEmpresa == null) ? null : Number(form.idEmpresa),
      Activo: form.activo
    };
    
    onSubmit?.(payload, mode);
  };

  const isSaveDisabled = !form.nombreRedSocial?.trim() || !!errors.nombreRedSocial;

  const Header = (
    <div className="roles-topbar" style={{ paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '0 0 auto' }}>
      <h3 className="roles-title">
        {mode === 'new' ? 'Nueva Red Social' : 'Editar Red Social'}
      </h3>
      <button className="roles-btn" onClick={onClose}>✕</button>
    </div>
  );

  const Body = (
    <div style={{ padding: '0 16px 16px 16px', display: 'grid', gridTemplateColumns: '1fr', gap: '1rem', overflowY: 'auto', flex: '1 1 auto' }}>
      <div style={{ marginTop: '0.8rem' }}>
        <label className="roles-title" style={{ fontSize: '.9rem' }}>Nombre de la Red Social *</label>
        <input
          className={`infoField ${errors.nombreRedSocial ? 'infoField--error' : ''}`}
          value={form.nombreRedSocial}
          onChange={(e) => handleChange('nombreRedSocial', e.target.value)}
          placeholder="Ej: Facebook, LinkedIn, Twitter..."
          style={{ width: '100%', marginTop: '0.6rem' }}
        />
        {errors.nombreRedSocial && (
          <small style={{ color: '#b91c1c', fontSize: '.75rem', marginTop: 4, display: 'block' }}>
            {errors.nombreRedSocial}
          </small>
        )}
      </div>
    </div>
  );

  const Footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', padding: '16px', flex: '0 0 auto' }}>
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button className="btn-action" onClick={handleSubmit} disabled={isSaveDisabled}>
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div className="roles-confirm-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="roles-confirm-card" style={{ width: 'min(640px, 95vw)', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
